import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("In-depth Case Studies to show you what I can offer and how I work")
const _hoisted_2 = { class: "section pt-5" }
const _hoisted_3 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_Filters = _resolveComponent("Filters")
  const _component_ProjectsGrid = _resolveComponent("ProjectsGrid")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { title: "Projects" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Filters, {
          name: "project-filters",
          filters: _ctx.projectFilters
        }, null, 8, ["filters"]),
        _createVNode(_component_ProjectsGrid, { projects: _ctx.projects }, null, 8, ["projects"])
      ])
    ])
  ], 64))
}